export const TRIAL_SUBSCRIPTION_DAYS = 30;
